import { getSearchQueryGivenRecordOfQueryParams } from "@faire/retailer-shared/search/searchRequest";
import getSearchPageLayout, {
  QueryParameters as SearchPageLayoutQueryParameters,
} from "@faire/web-api/api/v2/layout/search-page/get";
import { getQueryKey as getQueryKeySearchPageLayout } from "@faire/web-api/api/v2/layout/search-page/get-hooks";
import { useMemo } from "react";

import { useSearchPageParsedSearch } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageParsedSearch";

export const useSDUISearchPageQueryArgs = () => {
  const parsedSearch = useSearchPageParsedSearch();
  const searchQuery = useMemo(
    () => getSearchQueryGivenRecordOfQueryParams(parsedSearch),
    [parsedSearch]
  );

  return useMemo(() => {
    return {
      sduiLayoutQueryArgs: {
        key: getQueryKeySearchPageLayout(
          SearchPageLayoutQueryParameters.build({
            query: searchQuery,
          })
        ),
        fn: () =>
          getSearchPageLayout(
            SearchPageLayoutQueryParameters.build({
              query: searchQuery,
            })
          ),
        staleTime: Infinity,
      },
    };
  }, [searchQuery]);
};
